import {updateToolCall} from "../../../../../../../contextManagement/toolCallUpdater.ts";

export const formatSearchInternetToolMessage = (toolMessage: any, results: any, llmRequestRefs: any) => {
    const resultsArr = results.results ?? [];

    // Filter out URLs that have already been seen
    const urlsAlreadySeenSet = llmRequestRefs.current.additionalContext.urlsAlreadySeen;
    const newResults = resultsArr.filter((result: any) => {
        return !urlsAlreadySeenSet.has(result.url);
    });

    // Add new URLs to the seen set
    newResults.forEach((result: any) => {
        if (result.url) {
            urlsAlreadySeenSet.add(result.url);
        }
    });

    const searchToolMessage = `Add page links like [name](url)
Add images with ![name](url)
Add maps links like [name](http://maps.apple.com/?address=1125+Jackson+St,Albany,CA+94706)`;

    // Format the results for display (use newResults instead of resultsArr)
    const formattedResults = newResults.map((result: any) => {
        let resultString = `Title: ${result.name}\nURL: ${result.url}`;

        if (result.text) {
            resultString += `\nContent:\n"""\n${result.text}\n"""`;
        }

        return resultString;
    }).join('\n\n') || 'No new results found';

    const content = [{
        type: 'text',
        text: `Here are the results from the search:\n\`\`\`\n${formattedResults}\n\`\`\`\n\n${searchToolMessage}`
    }];
    const truncatedContent = [{
        type: 'text',
        text: `Here are the results from the search:\n\`\`\`\n<Truncated for brevity>\n\`\`\`\n`
    }];

    const urls: Array<{name: string, url: string, icon: string, content?: string, thumbnailUrl?: string}> = [];
    newResults.forEach((result: any) => {
        try {
            const urlObj = new URL(result.url);
            const urlImg = `https://icons.duckduckgo.com/ip3/${urlObj.hostname}.ico`;
            const urlEntry: {name: string, url: string, icon: string, content?: string, thumbnailUrl?: string} = {
                name: result.name || result.url.substring(result.url.indexOf('//') + 2),
                url: result.url,
                icon: urlImg
            };
            
            if (result.thumbnailUrl) {
                urlEntry.thumbnailUrl = result.thumbnailUrl;
            }

            urls.push(urlEntry);
        } catch (error) {
            // Skip invalid URLs
            console.warn('Invalid URL encountered:', result.url, error);
        }
    });

    updateToolCall(llmRequestRefs, toolMessage.tool_call_id, { urls });

    return {...toolMessage, content: content, truncatedContent: truncatedContent};
}
